import { render, staticRenderFns } from "./StudyQuizQuestionProblematic.vue?vue&type=template&id=2e4c12c8"
import script from "./StudyQuizQuestionProblematic.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionProblematic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports